import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const PersonCardIcon = ({
    size = 16,
    color = 'currentFill'
}: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 21 20"
        fill={color}
        xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#person_card_icon_svg__a)" fill="#212121">
            <path fillRule="evenodd"
                clipRule="evenodd"
                d="M4.75 8.5a2.75 2.75 0 1 1 4.764 1.873c1.052.7 1.736 1.93 1.736 3.298a.75.75 0 0 1-1.5 0c0-1.366-1.043-2.408-2.25-2.408s-2.25 1.042-2.25 2.408a.75.75 0 0 1-1.5 0c0-1.369.684-2.598 1.736-3.298A2.74 2.74 0 0 1 4.75 8.5ZM7.5 7.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z"/>
            <path d="M12 7.55a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75ZM12.75 9.404a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5h-2Z"/>
            <path fillRule="evenodd"
                clipRule="evenodd"
                d="M.75 5A2.75 2.75 0 0 1 3.5 2.25h14A2.75 2.75 0 0 1 20.25 5v10a2.75 2.75 0 0 1-2.75 2.75h-14A2.75 2.75 0 0 1 .75 15V5ZM3.5 3.75c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25h-14Z"/>
        </g>
        <defs>
            <clipPath id="person_card_icon_svg__a">
                <path fill="#fff" transform="translate(.5)" d="M0 0h20v20H0z"/>
            </clipPath>
        </defs>
    </svg>
);
PersonCardIcon.displayName = 'PersonCardIcon';
export default PersonCardIcon;
